



































import { Component, Vue, Emit } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
@Component({
  components: {
    CommonButton,
  },
})
export default class InviteMember extends Vue {
  private commonButtonColorInvite: string = '#4384f3';
  private commonButtonColorClose: string = '#4384f3';
  private inviteData = {
    email: '',
    message: '',
  }
  @Emit('closeInvitation')
  private closeInvitation(): void {}

  @Emit('invite')
  private invite() {
    return this.inviteData;
  }
}
